import React from 'react';
import { observer } from 'mobx-react-lite';
import { FiltersObject, PaginationDelegate } from 'store/general/paginationDelegate';
import {
  SubscribersSortBy,
  SubscribersSortOrder,
  SubscriberProgress,
  SubscriberAddEmployeesProgress,
} from 'types/electionService';
import { FilterDropdown } from 'components/common/general/CollectionManagementPanel/FilterDropdown';

const STATUS_FILTER_TITLES = {
  [SubscriberProgress.INCOMPLETE_PROFILE]: 'Incomplete Profile',
  [SubscriberProgress.INCOMPLETE_DEPENDENT]: 'Incomplete Dependent',
  [SubscriberProgress.PARTIALLY_ELECTED]: 'Partially Elected',
  [SubscriberProgress.ELECTION_COMPLETED]: 'Election Completed',
  [SubscriberProgress.FINALIZE_ELECTION]: 'Finalize Election',
};

interface SubscriberFilters extends FiltersObject {
  subProgress: SubscriberAddEmployeesProgress | null;
}

interface Props {
  paginationDelegate: PaginationDelegate<SubscribersSortBy, SubscribersSortOrder, SubscriberFilters>;
}

export const SubscriberEnrollmentProgressFilterDropdown: React.FC<Props> = observer(({ paginationDelegate }) => {
  if (!!paginationDelegate.filters.subProgress && !STATUS_FILTER_TITLES[paginationDelegate.filters.subProgress]) {
    throw new Error(`Unsupported filter value assigned! ${paginationDelegate.filters.subProgress}`);
  }
  return (
    <FilterDropdown
      filterName="Progress"
      $minWidth="32rem"
      optionsWidth="32rem"
      selectedFilterLabel={
        paginationDelegate.filters.subProgress ? STATUS_FILTER_TITLES[paginationDelegate.filters.subProgress] : 'All'
      }
      filtersList={[
        { value: null, label: 'All' },
        {
          value: SubscriberProgress.INCOMPLETE_PROFILE,
          label: STATUS_FILTER_TITLES[SubscriberProgress.INCOMPLETE_PROFILE],
        },
        {
          value: SubscriberProgress.INCOMPLETE_DEPENDENT,
          label: STATUS_FILTER_TITLES[SubscriberProgress.INCOMPLETE_DEPENDENT],
        },
        {
          value: SubscriberProgress.PARTIALLY_ELECTED,
          label: STATUS_FILTER_TITLES[SubscriberProgress.PARTIALLY_ELECTED],
        },
        {
          value: SubscriberProgress.FINALIZE_ELECTION,
          label: STATUS_FILTER_TITLES[SubscriberProgress.FINALIZE_ELECTION],
        },
        {
          value: SubscriberProgress.ELECTION_COMPLETED,
          label: STATUS_FILTER_TITLES[SubscriberProgress.ELECTION_COMPLETED],
        },
      ]}
      applyFilter={(value: string | null) => {
        paginationDelegate.setFilterValue('subProgress', value as SubscriberAddEmployeesProgress);
      }}
    />
  );
});
